export let DestacadosComponent = {
    selector: 'editarDestacados',
    template: require('./destacados.html'),
    bindings: {
        destacados: '<'
    },
    controller: class {

        /*@ngInject*/
        constructor(ConfiguracionService, $route, ToasterService) {
            Object.assign(this, {ConfiguracionService, $route, ToasterService});
            this.subiendoArchivo = false;
        }
        
        agregarDestacado(){
            if (this.codigoDestacado){
                this.ConfiguracionService.agregarDestacado(this.codigoDestacado)
                    .then( res => {
                        this.ToasterService.popUp('success','Articulo', 'Se ha agregado con éxito.');
                        this.$route.reload()
                    })
                    .catch( err => {
                        if (err.status === 404){
                            this.ToasterService.popUp('info','Articulo', 'El código no existe.');
                        } else {
                            this.ToasterService.error();
                        }
                    });
            } else {
                this.ToasterService.popUp('info','Articulo', 'Agregue un código.');
            }
        }

        borrarDestacado(id){
            this.ConfiguracionService.borrarDestacado(id)
                .then( data => {
                    this.ToasterService.popUp('success','Articulo', 'Se ha eliminado con éxito.');
                    this.$route.reload();
                });
        }


    }
};


// WEBPACK FOOTER //
// ./client/app/configuracion-route/destacados/destacados.component.js